import React from "react";
import "../nav/Navigation.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHourglass, faLocationCrosshairs} from "@fortawesome/free-solid-svg-icons";

function LoadingTag() {

    return (
        <>
            <div className={`d-inline-block`}>
                <FontAwesomeIcon className="animated zoomIn fa-solid" icon={faHourglass}/>
            </div>
        </>
    )
}

export default LoadingTag;
